<template>

<app-page v-if="is.loaded">

    <app-inner :condensed="true">

        <app-text v-html="page.content" />

    </app-inner>

</app-page>

</template>

<script>

import mixinPage from '@/mixin/page.js'

export default {

    mixins: [mixinPage]

}

</script>

<style scoped>

</style>
